var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoPiecesTransfert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3338",
    "data-name": "Groupe 3338",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.615,
    height: 14.615,
    viewBox: "0 0 14.615 14.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_926",
    "data-name": "Rectangle 926",
    width: 14.615,
    height: 14.615,
    fill: "#2762ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3335",
    "data-name": "Groupe 3335",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1163",
    "data-name": "Trac\\xE9 1163",
    d: "M6.876.023,1.332,0A1.326,1.326,0,0,0,0,1.332L.023,6.876a1.326,1.326,0,0,0,.388.932l6.418,6.418a1.326,1.326,0,0,0,1.876,0l2.761-2.761,2.761-2.761a1.326,1.326,0,0,0,0-1.876L7.809.412A1.326,1.326,0,0,0,6.876.023M2.282,2.282a.886.886,0,1,1,0,1.254.887.887,0,0,1,0-1.254m9.135,5.656L7.938,11.417a.53.53,0,0,1-.749-.749l3.479-3.479a.53.53,0,0,1,.749.749",
    transform: "translate(0 0)",
    fill: "#2762ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPiecesTransfert);
export default __webpack_public_path__ + "static/media/Picto-pieces-transfert.340aa84f2b48e8615c13feabead1dd8f.svg";
export { ForwardRef as ReactComponent };